import React, { ReactNode } from 'react'

export const MenuSectionHeader = ({
  header,
  badge,
  headingId
}: {
  header: string | null | undefined
  badge?: ReactNode
  headingId?: string
}) => {
  return header ? (
    <h3 id={headingId}>
      {header}
      {badge ? <div className='headerBadge'>{badge}</div> : null}
    </h3>
  ) : null
}
